import ServiceFilter from "./services/ServiceFilter";
export default class ServicesPage {
    constructor() {
        this.page = document.querySelector('.page.services');
        if (this.page) {
            new ServiceFilter();
        }
    }
}
